<template>
    <div
        class="left-sidebar p-0"
        :class="mobileView ? 'offcanvas offcanvas-start ' : 'bg-light d-none d-sm-block ' + (mini ? 'sidebar-mini ' : '')"
        id="offcanvasNavbar1"
        aria-labelledby="offcanvasWithBackdropLabel"
    >
        <div class="sidebarHeader text-primary" :class="mobileView ? 'd-block offcanvas-header' : ''">
            <div v-if="!mobileView" class="h-100 fw-bold d-flex flex-column justify-content-center align-items-center">
                <img :src="companyLogo" alt="..." />
                <span :class="mini ? 'd-none' : 'd-block mt-3'" style="">
                    {{ title ? title : TR.sidebar_header }}
                </span>
            </div>

            <template v-else>
                <div class="offcanvas-title h-100 fw-bold d-flex flex-column justify-content-center align-items-center" id="offcanvasWithBackdropLabel">
                    <img :src="companyLogo" alt="..." />
                    <span class="mt-3">{{ title ? title : TR.sidebar_header }}</span>
                </div>
                <button
                    type="button"
                    class="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                ></button>
            </template>
        </div>

        <div class="menu-content mb-auto scrollarea pt-3 text-start" :class="mobileView ? 'offcanvas-body ' : (mini ? 'px-01 ' : 'px-11 ')" >
            <ul class="ps-0">
                <template v-for="(menu, index) in menus" :key="index">
                    <template v-if="menu.title != '-' && (menu.visible === undefined || menu.visible == true)">
                        <li class="mb-1" v-if="menu.items">
                            <a
                                class="sidebar-item btn-toggle sidebar-menu-parent"
                                :class="( menu.collapsed !== undefined && menu.collapsed == true ? '' : 'collapsed' )"
                                :data-bs-toggle="mini ? 'dropdown' : 'collapse'"
                                :data-bs-target="`#sbm-${menu.id}-collapse`"
                                :aria-expanded="menu.collapsed !== undefined && menu.collapsed == true ? true : false"
                                :title="menu.title"
                                @click="setActiveCollapse(menu.id)"
                            >
                                <!-- :aria-expanded="isActiveCollapse(menu.id)" -->
                                <i class="p-1" :class="menu.icon" :title="menu.title"></i>
                                <span>{{menu.title}}</span>
                            </a>
                            <ul
                                class="fw-normal p-11"
                                :class="mini ? 'dropdown-menu' : ( 'collapse ' + ( menu.collapsed !== undefined && menu.collapsed == true ? 'show' : '' ) )"
                                :id="`sbm-${menu.id}-collapse`"
                            >
                                <!-- :class="mini ? 'dropdown-menu' : ( 'collapse ' + ( isActiveCollapse(menu.id) ? 'show' : 'show' ) )" -->
                                <template v-for="(item, key) in menu.items" :key="key">
                                    <li v-if="item.title == '-'">
                                        <hr class="dropdown-divider" />
                                    </li>
                                    <li v-else class="">
                                        <a
                                            v-if="G.getUserAccessToMenu(item.route_name)"
                                            :class="$route.name == item.route_name ? 'active' : ($route.name == 'index' && item.route_name == defaultSelectedMenu ? 'active' : '') "
                                            class="dropdown-item sidebar-menu-item"
                                            :alt="item.title"
                                            @click="setComponent(typeof item.route_name !== undefined || item.route_name != '' ? item.route_name : '', routesObj[item.route_name] != undefined ? routesObj[item.route_name].props.data.data : {} )"
                                        >
                                            <!-- :href="item.link" -->
                                            <i class="p-1" :class="item.icon" :alt="item.title"></i>
                                            <span>{{item.title}}</span>
                                        </a>
                                    </li>
                                </template>
                            </ul>
                            <!-- <div class="collapse show" id="home-collapse1" style></div> -->
                        </li>
                        <li v-else-if="menu.title == '-'">
                            <hr class="dropdown-divider" />
                        </li>
                        <li v-else-if="!menu.items && G.getUserAccessToMenu(menu.name)" class="">
                            <a class="dropdown-item" :class="menu.name == $route.name || ($route.name == 'index' && menu.name == defaultSelectedMenu) || ($route.meta.selected_menu && $route.meta.selected_menu == menu.name) ? 'active' : ''"
                            @click="setComponent(menu.route_name, routesObj[menu.route_name] != undefined ? routesObj[menu.route_name].props.data.data : {})"
                            :title="menu.title"
                            >
                            <!-- @click="setComponent(menu.route_name, routesObj.filter(e => menu.route_name == e.name).length ? routesObj.filter(e => menu.route_name == e.name)[0].props.data.data : {})" -->
                            <!-- :href="menu.link" -->
                                <i class="p-1" :class="menu.icon" :title="menu.title"></i>
                                <span>{{menu.title}}</span>
                            </a>
                        </li>
                    </template>
                    <li v-else-if="menu.title == '-' && (menu.role == 'user' || G.token_data()['role'] == 'admin')">
                        <hr class="dropdown-divider" />
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";

    import { G } from "@/_common";

    // import { menus } from "@/data/sidebarmenu";
    import { routesObj } from "@/system_modules/router/index";

    // import SVGLogo from '@/components/SVGLogo';

    export default {
        name: "SidebarMenu2C",
        props: {
            title: String,
            theme: {
                type: String,
                default: 'light'
            },
            width: {
                type: Number,
                default: 280,
                // validator(value) {
                //     return value >= 0 ? true : false;
                // }
            },
            setComponent: {
                type: Function,
                default(){
                    return null;
                }
            },
            defaultSelectedMenu: {
                type: String,
                default: G.defaultSelectedMenu
            },
            menus: {
                type: Array,
                default(){
                    return [];
                }
            }
        },
        components:{
            // SVGLogo,
        },

        setup() {
            const store = useStore();

            const showSidebar = ref(true);

            const mini = ref(false);
            const companyLogo = '/assets/images/logo.png' // G.systemData.image || ;

            // const mobileView = ref(true);
            const mobileView = ref(G.is_mobile());
            const TR = ref({});

            onMounted(async () => {
                // mini.value = mobileView.value
                //     ? false
                //     : store.getSidebarStatus();
                // await ajax
                //   .get(`menu/`, {
                //     headers: {
                //       Authorization: `${G.token}`,
                //     },
                //   })
                //   // ;
                //   // const postResult = fortmatResponse(result);
                //   // console.log(postResult);
                //   .then((e) => {
                //     if (e.data) {
                //       menus.value = e.data;
                //       menus.value.forEach((e, i)=>{
                //         if( e.page === G.current.value.page )
                //           activeItem.value = i;
                //       });
                //     }
                //   })
                //   .catch((error) => {
                //     G.removeClientData("AUTH_TOKEN");
                //   });
                // console.log(G.getClientData("activeCollapse"));
            });

            watchEffect(() => {
                TR.value = store.getTranslation();
                mini.value = mobileView.value
                    ? false
                    : store.getSidebarStatus();
                mobileView.value = G.is_mobile();
            });

            const isActiveCollapse = (item) => {
                let stored = G.getClientData("activeCollapse");
                return stored == item ? true : false;
            };

            const setActiveCollapse = (item) => {
                G.setClientData("activeCollapse", item);
            };

            // // const selectMenu = (route_name, activeIndex) => {
            // const selectMenu = (route_name) => {
            //     // props.selectMenuItem(activeIndex);
            //     if (typeof route_name !== undefined || route_name != "")
            //         props.setComponent(route_name);
            // };

            return {
                TR,
                G,
                // menus,
                mini,
                mobileView,
                companyLogo,
                setActiveCollapse,
                isActiveCollapse,
                // selectMenu,
                showSidebar,
                routesObj,
            };
        },
    };
</script>


<style lang="scss" scoped>
    .scrollarea {
        overflow-y: auto;
        overflow-x: hidden;
    }
    ul {
        list-style: none;
        padding-left: 0;
    }
    .left-sidebar {
        width: 250px;

        height: calc( 100vh - 3px );
        max-height: calc( 100vh - 3px );

        overflow-y: auto;
        -webkit-transition: 0.1s ease-out;
        -moz-transition: 0.1s ease-out;
        -o-transition: 0.1s ease-out;
        transition: all 0.1s ease-out;
        // border-right: 1px solid var(--bs-gray-400);
    }
    .main-content {
        -webkit-transition: 0.1s ease-out;
        -moz-transition: 0.1s ease-out;
        -o-transition: 0.1s ease-out;
    }
    .menu-content {
        max-height: calc(100vh - 165px);
    }
    .sidebar-mini .menu-content {
        max-height: calc(100vh - 85px);
    }

    .offcanvas-header .btn-close {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 15px;
    }

    .sidebarHeader {
        background: linear-gradient(70deg, rgb(243, 241, 241), rgb(182, 184, 184));
        color: #ffffff;
        img {
            height: 80px;
        }
        height: 160px;
        font-size: 1.05rem;
    }
    .sidebar-mini .sidebarHeader {
        img {
            width: 30px !important;
            height: auto;
        }
        // div {
        //     display: none;
        // }
        height: 60px;
    }

    .left-sidebar i {
        color: var(--body-color-primary);
        width: 24px;
        text-align: center;
        margin-right: 4px;
    }
    .sidebar-menu-item {
        cursor: pointer;
        align-items: center !important;
        display: flex !important;
    }
    .sidebar-menu-parent {
        background-color: rgba(226, 226, 226, 0.5);
        color: #000 !important;
    }
    .left-sidebar .sidebar-menu-item.active i {
        color: var(--bs-white);
    }
    .left-sidebar li {
        padding: 0rem;
    }
    .left-sidebar li a {
        padding: 0.5rem 0.4rem;
        cursor: pointer;
    }
    .left-sidebar li a:hover {
        background-color: var(--bs-primary-highlight);
        color: #ffffff;
    }
    .left-sidebar li a:hover i, .left-sidebar li a:hover span{
        // background-color: var(--bs-primary-highlight);
        color: #ffffff;
    }
    .left-sidebar .sidebar-menu-item {
        padding-left: 25px;
    }
    .left-sidebar.sidebar-mini li ul > li a {
        // padding-left: 0rem;
    }
    .left-sidebar.sidebar-mini {
        width: 50px;
        -webkit-transition: 0.1s ease-out;
        -moz-transition: 0.1s ease-out;
        -o-transition: 0.1s ease-out;
        transition: all 0.1s ease-out;
    }
    .left-sidebar.sidebar-mini li > a > i {
        margin-right: 0px;
    }
    .left-sidebar.sidebar-mini i {
        padding-right: 0px;
        // margin-right: 0px;
        text-align: center;
    }
    .left-sidebar.sidebar-mini li > ul li i{
        margin-right: 4px;
    }

    .sidebar-mini .dropdown-item span,
    .sidebar-mini .sidebar-item span,
    .sidebar-mini .link-dark span {
        display: none;
    }

    /** Sidebar mini menu open on the right */
    .sidebar-mini ul ul {
        position: absolute;
        margin-top: -40px;
        left: 70px;
        z-index: 2000;
        min-width: 200px;
    }
    .sidebar-mini ul ul .dropdown-item span {
        display: block;
    }
    .sidebar-mini .dropdown-menu {
        left: 52px !important;
        margin-top: -36px !important;
        font-size: inherit;
        border-radius: 0;
        padding: 0px;
    }
    .sidebar-mini .dropdown-item{
        padding: 0.5rem;
    }
    .sidebar-mini div > ul > li > .dropdown-item{
        justify-content: center;
        display: flex;
    }
    .dropdown-body {
        border-top: 1px solid var(--bs-gray-400);
        border-radius: 0.25rem;
    }
    .dropdown-body a {
        display: inline-flex;
        padding: 0.5rem 0.5rem;
        margin-top: 0.125rem;
        padding-left: 1.1rem;
        text-decoration: none;
    }
    .dropdown-item{
        padding: 0.4rem;
    }
    .dropdown-item.active i{
        color: var(--bs-light-rgb);
        background-color: unset;
    }
    .left-sidebar .sidebar-item{
        border-radius: 0;
    }
    .btn-toggle {
        display: inline-flex;
        align-items: center;
        padding: 0.4rem 0.4rem;
        color: rgba(90, 90, 90, 0.85);
        width: 100%;
    }
    .btn-toggle:hover,
    .btn-toggle:focus {
        color: rgba(90, 90, 90, 0.85);
    }
    .btn-toggle::after {
        width: 0.9em;
        line-height: 0;
        margin-left: auto;

        content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
    }
    // .btn-toggle::after {
    //     content: "";
    // }
    .btn-toggle[aria-expanded="true"] {
        color: rgba(90, 90, 90, 0.85);
    }

    a.btn-toggle::after {
        transform: rotate(90deg);
    }
    a.btn-toggle.collapsed::after {
        transform: rotate(0deg);
    }
    // .sidebar-mini .btn.btn-toggle{
    //     padding: .3rem !important;
    // }
    .sidebar-mini .btn-toggle::before {
        content: "";
    }
    .sidebar-mini .btn-toggle::after {
        margin: 4px 0px 0px 3px;
        content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 16 16' %3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
    }
    .sidebar-mini a.btn-toggle::after {
        transform: rotate(0deg);
    }
    /** Sidebar mini menu open on the right */


    .offcanvas-body {
        padding: 0px;
    }
    @media (max-width: 576px){
        .left-sidebar{
            padding: 0.2rem;
            height: 100vh;
            max-height: 100vh;
        }
        .menu-content {
            height: calc(100vh - 14px);
            max-height: calc(100vh - 14px);
        }
        .dropdown-item{
            padding: 0.25rem 0.6rem;
        }
        // .left-sidebar li ul > li {
        //     padding-left: 0.5rem;
        // }
    }

</style>

